/* maeda-en® - 2026/07/15 - Dawn標準slider-component/slideshow-componentのトラックにPCマウスでのドラッグスクロールを追加する共通処理。
   Featured Tabs / Recipe Slider / Hero Sliderで共有（タッチは元々ネイティブスクロールで対応済みのためマウスのみ対象）。
   トラックは常にroot配下の[id^="Slider-"]要素のため、親タグ名（slider-component/slideshow-component）は問わない。
   Hero Sliderのようにテキストオーバーレイがtrackの外（兄弟要素）にある場合は、そちらに`data-mae-drag-surface`を付けることで
   ドラッグ開始/追跡を拾えるようにする（ボタン・ナビ等は除外） */
window.maedaEnableSliderDragScroll = function (root) {
  if (!root) return;

  root.querySelectorAll('[id^="Slider-"]').forEach(function (track) {
    if (track.dataset.maeDragBound) return;
    track.dataset.maeDragBound = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var scrollLeft = 0;

    /* 画像のネイティブドラッグ（ブラウザ標準のdragstart）を止める。これが発生するとmousemove/mouseupが正しく発火せず「掴みっぱなし」になるため */
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    var stopDrag = function () {
      isDown = false;
      track.classList.remove('is-dragging');
    };
    window.addEventListener('mouseup', stopDrag);
    track.addEventListener('mouseleave', stopDrag);

    var handleMouseDown = function (e) {
      /* ボタン・ナビ等の上から始まった場合はドラッグ扱いにせず、通常のクリックに任せる */
      if (e.target.closest('button, .mae-hero__nav, .mae-hero__controls')) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    };

    var handleMouseMove = function (e) {
      if (!isDown) return;
      /* 保険: 何らかの理由でmouseupを取りこぼした場合、ボタンが実際に押されているかで復旧する */
      if (!(e.buttons & 1)) {
        stopDrag();
        return;
      }
      var walk = e.clientX - startX;
      if (Math.abs(walk) > 5) moved = true;
      if (moved) e.preventDefault();
      track.scrollLeft = scrollLeft - walk;
    };

    track.addEventListener('mousedown', handleMouseDown);
    track.addEventListener('mousemove', handleMouseMove);

    root.querySelectorAll('[data-mae-drag-surface]').forEach(function (surface) {
      surface.addEventListener('mousedown', handleMouseDown);
      surface.addEventListener('mousemove', handleMouseMove);
    });

    /* ドラッグ後のリリースでカードリンクへ誤遷移しないようにする */
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  });
};
